import React from "react"
import {useState} from "react";

function EditPage() {

    return (
    <>
    My Edit Page
    </>
    )
}

export default EditPage